import React from "react";

const TabItem = ({ index, title, clickTabHandler, activeTab }) => {
  const oddEven = index % 2 == 0 ? "even" : "odd";

  return (
    <li
      className={`tabs-title tps-accordion-item ${oddEven} ${
        activeTab === `#panel-${index}` ? " is-active" : ""
      }`}
      role="presentation"
      onClick={(event) => clickTabHandler(event)}
    >
      <a
        href={`#panel-${index}`}
        name={`panel-${index}`}
        role="tab"
        aria-selected={activeTab === `#panel-${index}`}
        aria-controls={`panel-${index}`}
        id={`#panel-${index}-label`}
        tabIndex={activeTab === `#panel-${index}` ? "0" : "-1"}
      >
        {title}
      </a>
    </li>
  );
};

export default TabItem;
